import { useEffect, useState } from 'react';
import { WhereToBuy } from './where-to-buy';
import { BannerWithCTA } from './banner-with-cta';
import { twMerge } from 'tailwind-merge';
import { StickyFooterData } from '../section/main';

interface StickyFooterComponentProps {
  name: 'WhereToBuy' | 'BannerWithCTA' | string;
  slug?: string;
  data?: StickyFooterData;
}

export const StickyFooter = ({
  name,
  slug,
  data,
}: StickyFooterComponentProps) => {
  const bannerData: StickyFooterData = data || {
    content:
      'If you are seeing this you should configure the Sticky Footer on your page.',
    buttonText: 'Home Page',
    buttonLink: 'http://mrcool.com',
    disabled: true,
  };
  const footers: Record<string, JSX.Element> = {
    WhereToBuy: <WhereToBuy slug={slug} />,
    BannerWithCTA: (
      <BannerWithCTA
        content={bannerData.content}
        buttonText={bannerData.buttonText}
        buttonLink={bannerData.buttonLink}
      />
    ),
  };
  const [showStickyFooter, setShowStickyFooter] = useState(false);
  const hasBannerData = data?.content && data?.buttonText && data?.buttonLink;

  useEffect(() => {
    let lastScrollY = window.scrollY;
    let ticking = false;

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const header = document.querySelector('header');
          const footer = document.querySelector('footer');

          if (!header || !footer) return;

          const isHeaderVisible = window.scrollY < 100;
          const isNearFooter =
            window.innerHeight + window.scrollY >
            document.documentElement.scrollHeight - 300;

          setShowStickyFooter(!isHeaderVisible && !isNearFooter);
          lastScrollY = window.scrollY;
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={twMerge(
        `mrc-sticky-footer fixed bottom-0 left-0 z-[999] w-full transform shadow-lg transition-all duration-200 ease-in-out`,
        showStickyFooter ? 'translate-y-0' : 'translate-y-full'
      )}
      style={{
        WebkitBackfaceVisibility: 'hidden',
        WebkitPerspective: 1000,
        WebkitTransform: 'translate3d(0,0,0)',
        backfaceVisibility: 'hidden',
        perspective: 1000,
        transform: 'translate3d(0,0,0)',
        visibility: showStickyFooter ? 'visible' : 'hidden',
      }}
    >
      {(!bannerData.disabled && hasBannerData && footers[name]) || null}
    </div>
  );
};
